import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AdminService } from 'src/app/services/admin.service';
import { AlertComponent } from '../alert/alert.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-add-comment',
  templateUrl: './add-comment.component.html',
  styleUrls: ['./add-comment.component.scss']
})
export class AddCommentComponent implements OnInit {
  commentForm!: FormGroup;
  loader: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public userId: number,
    private dialogRef: MatDialogRef<AddCommentComponent>,
    private dialog: MatDialog,
    private adminservice: AdminService,
    private datepipe: DatePipe
  ) { }

  ngOnInit() {
    this.formBuilder();
  }

  formBuilder(){
    this.commentForm = new FormGroup({
      commentId: new FormControl(0),
      comment: new FormControl('', Validators.required)
    })
  }

  saveComment(){
    if (!this.commentForm.valid) {
      return
    }

    const request = {
      "comentario_id": this.commentForm.value.commentId,
      "cliente_id": this.userId,
      "comentario": this.commentForm.value.comment,
      "registrado": this.datepipe.transform(new Date, 'yyyy-MM-dd HH:mm:ss')
    }
    this.loader = true;
    this.adminservice.saveComment(request).subscribe(
      (response)=>{
        this.loader = false;
        if (response.rtn) {
          this.dialogRef.close(request);
          this.dialog.open(AlertComponent,{
            width: '776px',
            disableClose: true,
            data: {
              type: 'success',
              title: 'Operación exitosa',
              description: 'Se ha cambiado el estado del cliente correctamente.',
              textButton: 'Entendido'
            }
          });
        }
      }
    );
  }

}
